import { Position } from 'geojson';

export interface RoofSegmentSolarPotential {
    azimuthDegrees: number;
    tiltDegrees: number;
    kwp: number;
    kwhPerKwp: number;

    // the properties below only exist for a PV analysis variation that is about to be created
    // and not loaded from persistance
    center?: Position;
    areaM2: number;
}

export enum SolarPotentialSourceType {
    GoogleSolar = 'GoogleSolar',
    AdmiSolar = 'AdmiSolar',
}
